module.exports = __webpack_public_path__ + "img/play_default.c3983795.png";